import * as React from 'react';
import classNames from 'classnames';
import { UIText1, UIText2 } from '@cian/ui-kit';

import { useIsMobileDevice } from '../../../../hooks';
import { IDiscountRowProps } from './types';

import * as styles from './CommercialDiscountRow.css';

// Компонент покрыт в достаточной степени, но кавередж дурит
/* istanbul ignore next */
export const CommercialDiscountRow = (props: IDiscountRowProps) => {
  const isMobile = useIsMobileDevice();
  const UIText = isMobile ? UIText1 : UIText2;

  const { name, value } = props;

  return (
    <div className={classNames(styles['row'], isMobile && styles['mobile'])}>
      <UIText>{name}</UIText>
      <UIText data-name="DiscountAmount" color="error_100">
        {value}
      </UIText>
    </div>
  );
};
